import React, { useState } from "react";
import {
  AlertInfo,
  Container,
  Row,
  SpanName,
  SpanValue,
} from "./styles/styleCardSummaryInfo";

import { Deposit, Icon } from "src/components/";
import { formatAmount } from "src/utils/number";
import { Badge } from "src/components/ui";
import { CopyToClipboard } from "react-copy-to-clipboard";
import copyIcon from "src/assets/copy.svg";
import CheckMark from "src/assets/CheckMark.svg";

export const Banner = (props) => {
  const { amount, FinamazeAccount, status } = props;
  const titles = [
    /* Separated. Step one shows "USD 5,000" and the summary of that same
       figure showed "$5000" — the one screen where the reader is checking the
       number before confirming it. */
    { title: "Deposit Amount", value: `$${formatAmount(amount)}` },
    // { title: "SNB Bank Account", value: FinamazeAccount },
    {
      title: "Payment Status",
      /* A state, so it wears the product's badge rather than being set as a
         figure beside one. */
      value: <Badge tone="warning">{status}</Badge>,
    },
  ];

  return (
    <AlertInfo>
      <Container>
        {titles.map((element) => (
          <Row key={element.title}>
            <SpanName>{element.title}</SpanName>
            <SpanValue>{element.value}</SpanValue>
          </Row>
        ))}
      </Container>
    </AlertInfo>
  );
};

export const ReferenceNumber = (props) => {
  const [copied, setCopied] = useState(false);
  const { formik } = props;
  return (
    <div style={{ marginTop: "30px", width: "100%" }}>
      <Deposit.Input
        id="transferReferNumber"
        name="transferReferNumber"
        onBlur={formik.handleBlur}
        error={""}
        placeholder="Confirmation Number provided by your bank"
        onChange={formik.handleChange}
        label=""
        suffix={
          <CopyToClipboard
            onCopy={() => setCopied(true)}
            text={formik.transferReferNumber}
          >
            {!copied ? (
              <Icon style={{ width: "20px" }} color="blue" src={copyIcon} />
            ) : (
              <Icon style={{ width: "20px" }} color="green" src={CheckMark} />
            )}
          </CopyToClipboard>
        }
      />
    </div>
  );
};
